<div class="row page-header">
    <div class="col-12">
        <h1>Parts &amp; Fluids Lookup <small>(Beta) Find parts by equipment, or equipment by part</small></h1>
    </div>
</div>

@if (!isInitialLoading) {
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>By Equipment</a>
            <ng-template ngbNavContent>
                <app-parts-fluids-by-equipment
                    [equipmentOptions]="equipmentOptions"
                    [selectedEquipment]="selectedEquipment"
                    (selectedEquipmentChange)="onEquipmentChanged($event)"
                    (selectedItemChange)="onItemChanged($event)"
                ></app-parts-fluids-by-equipment>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>By Part or Fluid</a>
            <ng-template ngbNavContent>
                <app-parts-fluids-by-item
                    [selectedItem]="selectedItem"
                    [isActive]="activeTab === 2"
                    (selectedItemChange)="onItemChanged($event)"
                    (selectedEquipmentChange)="onEquipmentChanged($event)"
                ></app-parts-fluids-by-item>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
}
